import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="site-footer">
      <div className="container-luxury py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_realty-complete/artifacts/qyc1eei7_Png%20Short%20Logo%20%2819%29.png" 
                alt="Bharat Estate" 
                className="h-24 md:h-28 w-auto grayscale brightness-150"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-6 max-w-md">
              India's premier luxury real estate platform. Discover exceptional properties across the nation
              with our curated collection of homes, apartments, and commercial spaces.
            </p>
            <div className="flex gap-4">
              <a href="#" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors" data-testid="social-facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors" data-testid="social-twitter">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors" data-testid="social-instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors" data-testid="social-linkedin">
                <Linkedin className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-['Plus_Jakarta_Sans'] text-lg font-semibold mb-6">Explore</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-about">About Us</Link></li>
              <li><Link to="/services" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-services">Home Services</Link></li>
              <li><Link to="/help-center" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-help-center">Help Center / FAQs</Link></li>
              <li><Link to="/packers-movers" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-movers">Packers &amp; Movers</Link></li>
              <li><Link to="/become-a-pro" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-pro">Become a Pro</Link></li>
              <li><Link to="/properties?listing_type=buy" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">Buy Property</Link></li>
              <li><Link to="/properties?listing_type=rent" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">Rent Property</Link></li>
              <li><Link to="/add-property" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">Sell Property</Link></li>
              <li><Link to="/emi-calculator" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">EMI Calculator</Link></li>
              <li><Link to="/compare" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">Compare Properties</Link></li>
              <li><Link to="/dashboard" className="text-[#D4AF37] hover:text-[#D4AF37]/80 transition-colors text-sm font-medium" data-testid="footer-link-premium">Premium · First month free</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-['Plus_Jakarta_Sans'] text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy-policy" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-privacy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-terms">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-refund">Refund &amp; Cancellation</Link></li>
              <li><Link to="/shipping-policy" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-shipping">Shipping &amp; Delivery</Link></li>
              <li><Link to="/grievance" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-grievance">Grievance Redressal</Link></li>
              <li><Link to="/account-deletion" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-link-account-deletion">Delete Account</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Plus_Jakarta_Sans'] text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <span className="text-white/70 text-sm">Serving 24+ cities across India</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#D4AF37] flex-shrink-0" />
                <div className="flex flex-col gap-0.5">
                  <a href="tel:+919465024516" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-phone">+91 94650 24516 <span className="text-white/40 text-xs">· India</span></a>
                  <a href="tel:+13652752286" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-phone-intl">+1 (365) 275-2286 <span className="text-white/40 text-xs">· US / Canada · NRI</span></a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#D4AF37] flex-shrink-0" />
                <a href="mailto:contact@bharat.estate" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm" data-testid="footer-email">contact@bharat.estate</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Top Cities (SEO) */}
        <div className="border-t border-white/10 mt-16 pt-8">
          <h4 className="font-['Plus_Jakarta_Sans'] text-lg font-semibold mb-5">Property by City</h4>
          <div className="flex flex-wrap gap-x-5 gap-y-3">
            {['Mumbai','Delhi','Bangalore','Pune','Hyderabad','Chennai','Gurgaon','Noida','Kolkata','Ahmedabad','Lucknow','Chandigarh','Kochi','Indore'].map((c) => (
              <Link
                key={c}
                to={`/real-estate/${c.toLowerCase()}`}
                className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm"
                data-testid={`footer-city-${c.toLowerCase()}`}
              >
                Property in {c}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
            <p className="text-white/50 text-sm">© {currentYear} Bharat Estate. All rights reserved.</p>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            <Link to="/privacy-policy" className="text-white/50 hover:text-white/80 text-sm transition-colors">Privacy</Link>
            <Link to="/terms" className="text-white/50 hover:text-white/80 text-sm transition-colors">Terms</Link>
            <Link to="/refund-policy" className="text-white/50 hover:text-white/80 text-sm transition-colors">Refund</Link>
            <Link to="/shipping-policy" className="text-white/50 hover:text-white/80 text-sm transition-colors">Shipping</Link>
            <Link to="/grievance" className="text-white/50 hover:text-white/80 text-sm transition-colors">Grievance</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
